import { prefixObjectValues } from '../utils';

const searchForm = {
  providerCategory: 'provider-category',
  aoiSpecialty: 'aoi-specialty',
  subspecialties: 'subspecialties',
  states: 'states',
  workLocation: 'work-location',
  minFte: 'min-fte',
  maxFte: 'max-fte',
  minContractValue: 'min-contract-value',
  maxContractValue: 'max-contract-value',
  startDate: 'start-date',
};

export default prefixObjectValues(searchForm, 'listing-search-form');
